/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { ITasksConfig, IDocumentsConfig } from 'app/core/models/essette-interfaces';
import { ITaskContainer, ISmartTaskBinding } from 'app/core/components/tasks/task';
import { DocumentsGrid } from 'app/core/components/documents/documents-grid';
import { UploadDocument } from 'app/core/components/documents/upload-document';
import { validate } from 'app/shared/elements/ess-rule';
import * as Core from 'app/core/models/essette-api';


/** View-Model for the Document Smart-Task Component  */
@autoinject()
export class SmartDocument extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected task!: Core.Task;
    protected targetId!: string;
    protected tasksConfig: ITasksConfig = {};
    protected documentsConfig: IDocumentsConfig = {};

    protected readonly: boolean = false;

    protected validate = validate;

    ////****************** Element References ***************************************////
    private $container!: ITaskContainer;
    private $documentsGrid!: DocumentsGrid;
    private $uploadDocument!: UploadDocument;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    protected async activate(params: ISmartTaskBinding): Promise<void> {
        if(!params || !params.container || !params.targetId || !params.task || !params.task.id || !params.tasksConfig || !params.tasksConfig.smartTasksConfig || !params.tasksConfig.smartTasksConfig.notesConfig) {
            throw TypeError(`${SmartDocument.name} Component Model not Bound.`);
        }

        const argumentId = params.task.definition?.type?.argument?.id || undefined;

        this.targetId = params.targetId;
        this.tasksConfig = params.tasksConfig;

        // copy documents config from smart tasks config
        this.documentsConfig = {
            ...params.tasksConfig.smartTasksConfig.documentsConfig,
            taskId: params.task.id,
            categoryId: argumentId
        };

        this.state = params.state || this.state;

        this.task = params.task;
        this.$container = params.container;
        this.readonly = params.readonly;
    }


    ////****************** Events ***************************************************////
    protected addDocumentSuccess(): void {
        if(this.$container) {
            this.$uploadDocument.reset();
            this.$documentsGrid.reload(true);
            this.$container.completeTask(true);
        }
    }

    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////

}
